import { render, staticRenderFns } from "./VideoDisplay.vue?vue&type=template&id=5bcf67fe&scoped=true"
import script from "./VideoDisplay.vue?vue&type=script&lang=js"
export * from "./VideoDisplay.vue?vue&type=script&lang=js"
import style0 from "./VideoDisplay.vue?vue&type=style&index=0&id=5bcf67fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf67fe",
  null
  
)

export default component.exports